<gruppe-logo [gruppe]="gruppe()" [logoUrl]="skjema().value.logo ?? null" [farge]="gruppefarge()" stil="xxstor"/>

<!-- Bruker ikke <bilde-velger-med-skalering> her da denne i så fall må konfigureres for å tillate ikke-kvadratiske bilder samt uendret bilde-oppløsning.
 Dette er mulig, men GUI for skalering/utsnitt blir da så avansert at bruker lett kan gjøre feil ..
 Videre antar vi at bruker som regel har tilgang til logo i format som egner seg til bruk i PDF uten videre skalering/endring av utsnitt  -->
<bilde-velger [skjemakontroll]="skjema().controls.logo"
              [maksStoerrelse]="maksAvatarStoerrelse"
              [velgBildeKnappDeaktivert]="velgBildeAktiv()"
              (vedBildeValgt)="bildeValgt($event)"
              (vedBildevelgerAktivert)="bildevelgerAktivert()">
  @if (gruppe()?.logoId) {
    {{ 'Endre logo'|translate }}
  } @else {
    {{ 'Velg logo'|translate }}
  }
</bilde-velger>

@if (erBildeValgt()) {
  <button mat-button type="button" (click)="tilbakestill()" class="tilbakestill" data-testid="tilbakestill">{{ 'Tilbakestill'|translate }}</button>
}

<p>
  {{ 'Logo vises med maksimal størrelse på 1500px bredde og 240px høyde i genererte PDF-dokumenter'|translate }}
</p>

<button mat-stroked-button type="button" class="fargevelger" ngx-colors-trigger [formControl]="skjema().controls.farge" format="hex" colorPickerControls="no-alpha" acceptLabel="{{'Velg' | translate}}"
        cancelLabel="{{'Avbryt' | translate}}">
  <div class="fargevelger-label">
    <span class="farge" [style.background]="gruppefarge()"></span>
    <span>{{ 'Gruppefarge'|translate }}</span>
  </div>
</button>

@if (skjema().controls.farge.hasError('pattern')) {
  <div class="valideringsfeil">
    {{ '{farge} er en ugyldig fargekode'|translate: {farge: skjema().controls.farge.errors!.pattern.actualValue} }}
  </div>
}


